export default "__VITE_ASSET__C586rgqi__"